import styles from './index.module.scss'
import { Checkbox, message } from 'antd';
import Utils from '@utils/utils'
import Iconfont from '@utils/Iconfont';
import { DownloadOutlined, LoadingOutlined, CloseOutlined } from '@ant-design/icons';
import PSAIModal from '@PSAIComponents/PSAIModal';
import { useNavigate } from 'react-router-dom';
import API, { commonApiInvoker } from '@api/api.js';
import { throttle } from 'lodash';
import { useMemo, useState } from 'react';
import { IMAGE_TYPE } from '@utils/CONST'

const ProjectListItem = (props) => {
    const navigate = useNavigate();
    const { isSelected, item, selectedList } = props;
    const [downLoading, setDownLoading] = useState(false);

    const deleteClick = () => {
        PSAIModal.confirm({
            title: "删除项目",
            content: "删除后项目将无法找回，确定删除吗？",
            onOk: deleteProject
        })
    }

    const deleteProject = () => {
        commonApiInvoker(API.deleteProject({
            projectId: item?.id
        })).then(res => {
            message.success('删除成功！')
            props.listProjectv2()
        })
    }
    const projectBatchDownloadMeta = () => {
        // const status = Utils.checkFirstDownLoad(() => projectBatchDownload())
        // if (!status) return
        projectBatchDownload()
    }
    const projectBatchDownload = throttle(() => {
        setDownLoading(true)
        commonApiInvoker(API.projectPatchDownload({
            ids: [item?.id]
        }), setDownLoading).then(res => {
            Utils.downloadFileWithToken(res).then(() => {
                message.success('下载成功');
            }).catch(() => {
                message.warning('下载失败，请稍后重试');
            }).finally(() => {
                setDownLoading(false)
            })
        })
    }, 1000)

    const isCollect = useMemo(() => {
        return item?.id === 'collect'
    }, [item])

    const isVideo = useMemo(() => {
        return IMAGE_TYPE.MODEL_VIDEO == item?.imageType || IMAGE_TYPE.IMAGE_TO_VIDEO == item?.imageType
    }, [item])


    return (
        <div className={styles.ProjectListItem}>
            <div className={styles.imgBox} onClick={() => navigate(`/home/myProject/${item.id}/detail`)}>
                <img src={Utils.getImgThumbnail(item.mainImage?.split(',')[0])} alt="" />
                {!isCollect && <div className={styles.hoverMask}>查看合集</div>}
                {isVideo && <i className={styles.VideoIcon}></i>}
                {item.allFailed && <div className={styles.failMask}>
                    <Iconfont className={styles.iconfont} type="icon-imageErrorOutline" />
                    <p>生成失败</p>
                </div>}
            </div>
            <p className={styles.proTitleBox}>
                <span className={styles.title}>{item.projectName}</span>
                {
                    !isCollect && <span className={styles.options}>
                        {
                            downLoading ? <LoadingOutlined className={styles.Icon} /> :
                                <DownloadOutlined className={styles.Icon} onClick={projectBatchDownloadMeta} />
                        }
                        <Iconfont type="icon-DeleteOutlined" className={styles.Icon} onClick={deleteClick} />
                    </span>
                }
            </p>
            {
                !isCollect && <p className={styles.creatDate}>生成日期 &nbsp;{item.updatedTime}</p>
            }
            {(item.memberName && item.orgData) && <span title={item.memberName} className={styles.memberName}>{item.memberName}</span>}
            {
                isSelected &&
                <div className={styles.SelectMask} onClick={() => props.selectCurrentItem(item?.id)}>
                    <Checkbox
                        className={styles.ItemSelect}
                        checked={selectedList.includes(item?.id)}
                    ></Checkbox >
                </div>
            }
        </div>
    )
}

export default ProjectListItem
